import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Injectable()
export class PageTitleService  {

    private initialTitle: string;

    constructor(private titleService: Title) {
    }

    /** see IPageTitleService.getTitle */
    public getTitle = () => {
        return this.titleService.getTitle();
    }

    /** see IPageTitleService.setTitle */
    public setTitle = (newTitle: string) => {
        this.initialTitle = newTitle;
    }

    /** see IPageTitleService.changeTitle */
    public changeTitle = (newTitle: string) => {
        this.titleService.setTitle(newTitle);
        this.initialTitle = newTitle;
    }
}
